export const columns = [
  { dataField: 'product_name', text: 'Product', headStyle: { width: '13%' }, style: { width: '13%' } },
  { dataField: 'year', text: 'Year', headStyle: { width: '6%' }, style: { width: '6%' } },
  { dataField: 'number', text: 'Number', headStyle: { width: '6%' }, style: { width: '6%' } },
  { dataField: 'brief_description', text: 'Objective (Short)', headStyle: { width: '22%' }, style: { width: '22%' } },
  { dataField: 'long_description', text: 'Objective (Long)', headStyle: { width: '47%' }, style: { width: '47%' } },
];
